import { render, staticRenderFns } from "./vLandingConfig.vue?vue&type=template&id=c343a302&scoped=true"
import script from "./vLandingConfig.vue?vue&type=script&lang=js"
export * from "./vLandingConfig.vue?vue&type=script&lang=js"
import style0 from "./vLandingConfig.vue?vue&type=style&index=0&id=c343a302&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c343a302",
  null
  
)

export default component.exports